export const ADMIN_PERMISSION_DEFAULTS = {
  admin_can_manage_users: '1',
  admin_can_manage_balances: '1',
  admin_can_manage_roles: '1',
  admin_can_manage_settings: '1',
  admin_can_manage_services: '1',
  admin_can_manage_orders: '1',
  admin_can_manage_deposits: '1',
  admin_can_manage_support: '1',
  admin_can_manage_service_testing: '1',
};

export const isAdminRole = (role) => role === 'admin' || role === 'super_admin';

export const isSuperAdminRole = (role) => role === 'super_admin';

export function canAccessAdminArea(user, settings, area) {
  if (isSuperAdminRole(user?.role)) return true;
  const permissions = { ...ADMIN_PERMISSION_DEFAULTS, ...settings };

  switch (area) {
    case 'users':
      return (
        permissions.admin_can_manage_users !== '0' ||
        permissions.admin_can_manage_balances !== '0' ||
        permissions.admin_can_manage_roles !== '0'
      );
    case 'orders':
      return permissions.admin_can_manage_orders !== '0';
    case 'services':
      return permissions.admin_can_manage_services !== '0';
    case 'settings':
      return permissions.admin_can_manage_settings !== '0';
    case 'deposits':
      return permissions.admin_can_manage_deposits !== '0';
    case 'support':
      return permissions.admin_can_manage_support !== '0';
    case 'service_testing':
      return permissions.admin_can_manage_service_testing !== '0';
    case 'dashboard':
    default:
      return true;
  }
}
